import { useMemo } from 'react';
import { NextPage } from 'next';

import { PageSection } from 'types/pages';

import Head from 'components/layout/Head';
import PageContainer from 'components/layout/PageContainer';
import SectionsWrapper from 'components/layout/SectionsWrapper';

import SectionForms from './sections/Forms';
import StyledComponent from './styles';
import { Props } from './types';


const PagePasswordReset: NextPage<Props> = ({ localTranslations, metaTranslations }) => {
    const sections: PageSection[] = useMemo(() => [{
        slug: 'forms',
        order: 1,
        isVisible: true,
        children: (slug, translations) => (
            <SectionForms
                key={slug}
                translations={translations}
            />
        ),
    }], []);

    return (
        <StyledComponent className="page-password-reset">
            <Head
                {...metaTranslations}
            />
            <PageContainer>
                <SectionsWrapper
                    sections={sections}
                    localTranslations={localTranslations}
                />
            </PageContainer>
        </StyledComponent>
    );
};

export default PagePasswordReset;
